export default {
  ProvinceModel: function (dict) {
    this.provinceCode = dict.province_code
    if (!this.provinceCode) {
      this.provinceCode = dict.ProvinceCode
    }

    this.provinceName = dict.province_name
    if (!this.provinceName) {
      this.provinceName = dict.ProvinceName
    }

    this.provinceNameEN = dict.ProvinceName_EN
  },
  DistrictModel: function (dict) {
    this.districtCode = dict.district_code
    if (!this.districtCode) {
      this.districtCode = dict.DistrictCode
    }

    this.districtName = dict.district_name
    if (!this.districtName) {
      this.districtName = dict.DistrictName
    }

    this.districtNameEN = dict.district_name_EN
    if (!this.districtNameEN) {
      this.districtNameEN = dict.DistrictName_EN
    }

    this.provinceCode = dict.province_code
    if (!this.provinceCode) {
      this.provinceCode = dict.ProvinceCode
    }
  },
  SubDistrictModel: function (dict) {
    this.subdistrictCode = dict.subdistrict_code
    if (!this.subdistrictCode) {
      this.subdistrictCode = dict.SubDistrictCode
    }

    this.subdistrictName = dict.subdistrict_name
    if (!this.subdistrictName) {
      this.subdistrictName = dict.SubDistrictName
    }

    this.provinceCode = dict.provinceCode
    if (!this.provinceCode) {
      this.provinceCode = dict.ProvinceCode
    }

    this.districtCode = dict.districtCode
    if (!this.districtCode) {
      this.districtCode = dict.DistrictCode
    }

    this.subdistrictNameEN = dict.SubDistrictName_EN
    this.city = dict.city
    this.zipcode = dict.zip_code
  },
}
